import React from 'react';

interface ConsoleToggleProps {
  onClick: () => void;
  isActive: boolean;
}

const ConsoleToggle: React.FC<ConsoleToggleProps> = ({ onClick, isActive }) => {
  return (
    <button 
      className={`fixed bottom-5 right-20 w-14 h-14 rounded-full ${
        isActive ? 'bg-green-600 hover:bg-green-700' : 'bg-purple-600 hover:bg-purple-700'
      } border-none text-white cursor-pointer flex items-center justify-center shadow-lg transition-all duration-300 z-[10000] hover:scale-110 hover:shadow-xl active:scale-95`}
      onClick={onClick}
      aria-label="Toggle console panel"
      title="Toggle console panel"
    >
      <svg 
        width="28" 
        height="28" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <polyline points="4 17 10 11 4 5" />
        <line x1="12" y1="19" x2="20" y2="19" />
      </svg>
    </button>
  );
};

export default ConsoleToggle;
